class SiteHeader extends HTMLElement {
  static classes = {
    bg: 'bg'
  }
  static selectors = {
    product: 'main-product',
    gallery: '[data-mobile-gallery]'
  }
  static largeWidth = 1200;
  mainProduct; gallery;

  constructor() {
    super();
    this.init();
  }

  init = () => {
    this.mainProduct = document.querySelector(SiteHeader.selectors.product);
    this.gallery = document.querySelector(SiteHeader.selectors.gallery);
    if(this.dataset.scroll != undefined){
      this.setBg();
      window.addEventListener('scroll', () => {
        this.setBg();
      });

      this.querySelector('bs-nav').addEventListener('theme.nav_changed', (e) => {
        this.setBg();
      });
    }
  }

  setBg = () => {
    if(this.mainProduct != null && this.mainProduct != undefined){
      const height = document.body.clientWidth < SiteHeader.largeWidth ? this.gallery.offsetHeight : this.mainProduct.offsetHeight;
      if(this.dataset.scroll != undefined){
        if(window.scrollY >= height || document.querySelector('bs-nav').open){
          this.setSolid();
        }
        else {
          this.setTransparent();
        }
      } 
    } 
  }

  setTransparent = () => {
    this.classList.remove(SiteHeader.classes.bg);
    document.querySelector('meta[name="theme-color"]').setAttribute('content', this.dataset.secondary);
  }

  setSolid = () => {
    this.classList.add(SiteHeader.classes.bg);
    document.querySelector('meta[name="theme-color"]').setAttribute('content', this.dataset.primary);
  } 
}
if (!window.customElements.get("site-header")) {
  window.customElements.define("site-header", SiteHeader);
}